// Helper-home wrapper around the canonical Row primitive. Same spec as the
// app's navigation rows: glass card, 44x44 leading visual, title, subtitle,
// and trailing chevron.
//
// Two icon modes:
//   - Lucide `Icon` prop  → drawn bare, centred in the 44x44 slot, in the
//                            title's colour (no shape behind it)
//   - `imageSource` prop  → drawn as a 44x44 image with mixBlendMode overlay
//                            (web), no backdrop. Use for 3D-rendered icons
//                            from src/apps/moon/assets/images/you-icons.
import { View, Image, Platform } from "react-native";
import { type LucideIcon } from "lucide-react-native";
import { Row } from "@louise/moon-ui";
import { EMBER } from "@louise/moon-ui/theme/tokens";

type Props = {
  Icon?: LucideIcon;
  imageSource?: number;
  title: string;
  subtitle: string;
  iconColor?: string;
  onPress: () => void;
};

export default function HelperHomeActionCard({
  Icon,
  imageSource,
  title,
  subtitle,
  iconColor = EMBER.colors.text,
  onPress,
}: Props) {
  const leading =
    imageSource !== undefined ? (
      <Image
        source={imageSource}
        style={{
          width: 44,
          height: 44,
          ...(Platform.OS === "web" && { mixBlendMode: "overlay" }),
        }}
        resizeMode="contain"
      />
    ) : Icon ? (
      <View
        style={{
          width: 44,
          height: 44,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Icon size={22} color={iconColor} strokeWidth={1.5} />
      </View>
    ) : null;

  return (
    <Row
      onPress={onPress}
      title={title}
      subtitle={subtitle}
      leading={leading}
      leadingSize={44}
      gap={14}
      paddingHorizontal={18}
      paddingVertical={18}
      style={{ marginTop: 12 }}
      titleStyle={{
        fontSize: 16,
        fontWeight: "600",
        color: EMBER.colors.text,
      }}
      subtitleStyle={{
        fontSize: 13,
        color: EMBER.colors.textLight,
        lineHeight: 18,
      }}
    />
  );
}
